/**
 * Semen order action types for URL parameters.
 */
export const OrderActions = {
    View: 'view',
    Edit: 'edit',
    Payment: 'payment',
    ExtraDose: 'ExtraDose',
};
